import React from 'react';
import { Outlet } from 'react-router-dom';
import SettingsHeader from '@/pages/Settings/SettingsHeader';
import ConnectSubNav from '../ConnectSubNav';

const CONFIG_SUBNAV_ITEMS = [
  { key: 'api-tokens', label: 'API Tokens' },
  { key: 'webhooks', label: 'Webhooks' },
  { key: 'alerts', label: 'Alerts' },
];

export const ConfigLayout: React.FC = () => {
  return (
    <>
      <SettingsHeader headerText="Config" subText="Manage API tokens, webhooks, and alerts." />
      <ConnectSubNav basePath="/connect/config" items={CONFIG_SUBNAV_ITEMS} />
      <Outlet />
    </>
  );
};

export default ConfigLayout;
